export default __webpack_public_path__ + "static/media/globogabipngv2.522ab4d4.png";